import React from 'react';
import '../../Common/Custom.css';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { Divider } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';

import QueryForm from '../../Common/QueryForm';
import PageTabs from '../../Common/PageTabs';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow:'none',
}));

function Nodata() {

  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpen2(false);
  };

  return (
    <div className="verify-product">

<Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
       <div className='scan-alert'>
                <strong>Submit Form</strong>
                <QueryForm formClassName="formsubmitt" onSuccess={() => { setOpen(false); handleClickOpen2(); }} />
               </div>
      </Dialog>


      <Dialog show={open2}
                onHide={() => setOpen2(false)}
        open={open2}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" onBackdropClick="false"
      >
       <div className='scan-alert'>
                <strong>Thanks for submitting your query.</strong>
               
        <DialogActions className='ques-button'>  

              <Button variant="contained" color="success" onClick={handleClose}>Ok</Button>
        </DialogActions>
               </div>
      </Dialog>

      <div className="product-box">
       <Card className='card-box'>
          <Card className='inner-card mb-10'>
          <Grid container spacing={2}>
          
           
            <Grid item md={12} xs={12}>
              <Item>
                <div className='scan-status'><ReportProblemIcon/>This code has been Possible counterfeit!
                </div>

                {/* <div className='scan-status'><ReportProblemIcon/>Product not found.
                </div> */}
                <Divider/>
                <div className='scan-alert scan-alert2'>
                <strong>Do you want to raise query for this?</strong>
                <Stack spacing={2} direction="row" className="stack-button-group">
                  <Button variant="contained" size="small" color="success" onClick={handleClickOpen}>Yes</Button>
                </Stack>
               </div>

              

              </Item>
            </Grid>
          </Grid>
          </Card>
          

          <Card className='inner-card mb-10'>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <Item>
              <div className='helplinetitle'>Helpline For Any Query  <a href="tel:+91-9582 77 5555"><CallIcon/> +91-9582 77 5555</a></div>

              </Item>
            </Grid>
          </Grid>
          </Card>

       </Card>

       <PageTabs buyHref="https://amzn.eu/d/2laVQDS" />

      </div>
    </div>
  );
}

export default Nodata;
